import { render, staticRenderFns } from "./edizm.vue?vue&type=template&id=1a2e4b5a"
import script from "./edizm.vue?vue&type=script&lang=js"
export * from "./edizm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports